var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "shadow-sm"
  }, [_c('b-card-title', {
    staticClass: "mb-4 pt-6 px-6 d-flex justify-content-between"
  }, [_c('div', [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "bar-chart-fill",
      "variant": "primary"
    }
  }), _c('span', [_vm._v("Relação Financeira")])], 1), _c('FiltroPeriodo', {
    attrs: {
      "value": _vm.periodo,
      "default-label": "Hoje",
      "auto-apply-on-mount": !_vm.ignoreInitialApply
    },
    on: {
      "apply": _vm.onApplyPeriodo
    }
  })], 1), _c('b-card-body', [_vm.loading ? [_c('div', {
    staticClass: "col-12"
  }, [_c('b-skeleton', {
    staticClass: "mx-auto mb-3",
    attrs: {
      "width": "100%",
      "height": "18px"
    }
  }), _c('b-skeleton', {
    staticClass: "mx-auto",
    attrs: {
      "width": "100%",
      "height": "48px"
    }
  })], 1)] : [_c('apexchart', {
    attrs: {
      "height": "280",
      "options": _vm.chartOptions,
      "series": _vm.chartSeries
    }
  })]], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };